/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import {TFacet} from "@/app/types/TFacet";
import {getCookie} from "@/app/utils/cookie";
import {CURRENCY_CODE_COOKIE, USER_GROUP_COOKIE} from "@/app/constants";
import {algoliaConfig, PRICE_GROUP_DEFAULT} from "@/app/config/algoliaConfig";

export const transformAlgoliaFacetsSettings = (options: {
    algoliaFacetsString?:string|null,
    facetsNumber?:string|null,
}) => {
    const algoliaFacets = options.algoliaFacetsString ? JSON.parse(options.algoliaFacetsString) : {};
    const algoliaFacetsConfig:TFacet[] = [];
    const facetsNumber = options.facetsNumber ? parseInt(options.facetsNumber) : 12;

    const userGroup = getCookie({name: USER_GROUP_COOKIE});
    const priceGroup = !userGroup || userGroup === 'null' ? PRICE_GROUP_DEFAULT : `group_${userGroup}`;
    const currency = getCookie({name: CURRENCY_CODE_COOKIE}) ?? '';

    for (let key in algoliaFacets) {
        if(algoliaFacets[key].label === "") {
            continue; // Skip facets without labels
        }
        const attribute = algoliaFacets[key].attribute === 'price' && currency && priceGroup ?
            `${algoliaFacets[key].attribute}.${currency}.${priceGroup}` : algoliaFacets[key].attribute; // Customization for price facet

        algoliaFacetsConfig.push({
            attribute: attribute,
            label:  algoliaFacets[key].label,
            type:  algoliaFacets[key].type,
            options: {
                operator:  algoliaFacets[key].type === 'conjunctive' ? 'or' : 'and',
                searchable: algoliaFacets[key].searchable === '1',
                showMore: true,
                showMoreLimit: algoliaConfig.itemsLimitInFacet,
                limit: facetsNumber,
            },
        });
    }

    return algoliaFacetsConfig;
}